"use strict";
exports.__esModule = true;
exports.chart_donut_threshold_dynamic_pie_Height = {
  "name": "--pf-chart-donut--threshold--dynamic--pie--Height",
  "value": 202,
  "var": "var(--pf-chart-donut--threshold--dynamic--pie--Height, 202)"
};
exports["default"] = exports.chart_donut_threshold_dynamic_pie_Height;